import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';
declare let $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements AfterViewInit, OnInit {

    public menuItems: Array<any>;
    public router: Router;
    public sbclickEvent = 'click.sidebar-toggle';
    public $doc: any = null;
    public showSidebar = false;
    sidebarItem;

    @ViewChild('sidebar') sidebar!: ElementRef;

    constructor(
        public menuService: MenuService,
        public settings: SettingsService,
        public injector: Injector,
         private cd: ChangeDetectorRef
    ) {}

    public ngOnInit() {

        this.menuItems = this.menuService.menuItems;

        this.router = this.injector.get(Router);

        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close sidebar on route change
            this.settings.layout.asideToggled = false;
        });
    }

    ngAfterViewInit(): void {
        this.sidebarItem = this.sidebar ? [this.sidebar] : [];
        this.cd.detectChanges();
    }

    public closeSidebar(): void {
        this.settings.layout.asideToggled = false;
    }

    public toggleSubmenuClick(event) {
            event.preventDefault();

            const target = $(event.target || event.srcElement || event.currentTarget);
            let ul = target;
            let anchor = target;

            // find the UL
            if (!target.is('a')) {
                anchor = target.parent('a').first();
            }
            const icon = anchor.find('i');
            ul = anchor.next();

            // hide other submenus
            const parentNav = ul.parents('.sidebar-subnav');
            $('.sidebar-subnav').each((idx, el) => {
                const $el = $(el);
                const elIcon = $el.siblings('a').find('i');
                // if element is not a parent or self ul
                if (!$el.is(parentNav) && !$el.is(ul)) {
                    this.closeMenu($el, elIcon);
                }
            });

            // abort if not UL to process
            if (!ul.length) {
                return;
            }

            // any child menu should start closed
            ul.find('.sidebar-subnav').each((idx, el) => {
                this.closeMenu($(el), icon);
            });

            // toggle UL height
            // eslint-disable-next-line radix
            if (parseInt(ul.height(), 0)) {
                this.closeMenu(ul, icon);
            } else {
                // expand menu
                ul.on('transitionend', () => {
                    ul.height('auto').off('transitionend');
                }).height(ul[0].scrollHeight);
                // add class to manage animation
                ul.addClass('opening');
                icon.addClass('fa-angle-down');
                icon.removeClass('fa-angle-right');
            }

    }

    // Close menu collapsing height
    public closeMenu(elem, icon) {
        elem.height(elem[0].scrollHeight); // set height
        elem.height(0); // and move to zero to collapse
        elem.removeClass('opening');
        icon.addClass('fa-angle-right');
        icon.removeClass('fa-angle-down');
    }

    public isSidebarCollapsed() {
        return this.settings.layout.isCollapsed;
    }
    public isSidebarCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }
    public isEnabledHover() {
        return this.settings.layout.asideHover;
    }
}
